export default __webpack_public_path__ + "static/media/溶解氧DO探头.207dc8e3.jpg";